import { Box, chakra, shouldForwardProp, Text } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { COMMON_WEB_PATH } from "../../../constant";
import Count from "../../../pages/WebSocket/components/Count";
import JackpotNumber from "./JackpotNumber";
import { isValidMotionProp, motion, useSpring } from "framer-motion";
import { formatNumber } from "../../../utils/formatNumber";
import { specialTextGradientStyle } from "../../../utils/specialTextGradientStyle";

const splitNumber = (num) => {
  const numStr = formatNumber(num, { point: false }).toString();
  const cleanStr = numStr.replace(/,/g, "");
  const digitCount = cleanStr.length;

  const digits = numStr.split("");
  const units = [];

  let digitIndex = 0;

  for (const ch of digits) {
    if (ch === ",") {
      units.push("");
    } else {
      const exponent = digitCount - digitIndex - 1;
      units.push(Math.pow(10, exponent));
      digitIndex++;
    }
  }
  return {
    digits: digits,
    units: units,
  };
};

const JackpotItem = ({ type, jackpotValue = 0, trigger } = {}) => {
  const animatedValue = useSpring(0, {
    stiffness: 100,
    damping: 30,
  });

  useEffect(() => {
    if (jackpotValue > 0) {
      animatedValue.set(jackpotValue);
    }
  }, [jackpotValue, animatedValue]);

  useEffect(() => {
    if (trigger > 0 && jackpotValue > 0) {
      // 先設為 0 再設回原值,製造滾動效果
      animatedValue.set(0);
      setTimeout(() => {
        animatedValue.set(jackpotValue);
      }, 50);
    }
  }, [trigger, jackpotValue, animatedValue]);

  const { digits, units } = splitNumber(jackpotValue);

  return (
    <Box
      bgImage={`url(${COMMON_WEB_PATH}/now888/jackpot/${type}.png)`}
      bgSize={"100% 100%"}
      w={"100%"}
      maxW="300px"
      h={{
        base: "65px",
        md: "75px",
      }}
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
      pt={"0.8em"}
      pb={"1.9em"}
    >
      <Box
        display="flex"
        alignItems={"center"}
        justifyContent={"center"}
        h={"100%"}
        w="100%"
      >
        {digits?.map((digit, index) => {
          const isLastNumber = index === digits.length - 1;
          return (
            <Box
              position={"relative"}
              w={"1em"}
              h="100%"
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              overflow="hidden"
            >
              {digit == "," ? (
                <Box
                  position={"absolute"}
                  display={"flex"}
                  justifyContent={"center"}
                  color="white"
                  fontWeight={900}
                  fontSize={"1.5em"}
                >
                  {","}
                </Box>
              ) : (
                [...Array(10).keys()].map((i) => {
                  return (
                    <JackpotNumber
                      place={units[index]}
                      mv={animatedValue}
                      isLastNumber={isLastNumber}
                      number={i}
                      key={i}
                    />
                  );
                })
              )}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default JackpotItem;
